import React from 'react'
import { Link } from 'react-router-dom'
import { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import useCsrfToken from '../hooks/useCsrfToken';

export default function Paquetesall({ initialShortcutTag = '' }) {
    const { csrfToken } = useCsrfToken();
    const [paquetes, setPaquetes] = useState([]);
    const API_URL = process.env.REACT_APP_API_URL;
    const [isLoading, setIsLoading] = useState(true);
    const [tags, setTags] = useState([]);
    const member = useSelector((state) => state.authentication?.member);
    const [localmember, setLocalmember] = useState([]);
    useEffect(() => {
        if (member.length > 0) {
            setLocalmember(JSON.parse(member));
        }
        const transformData = (data) => {
            const formatPrice = (price) => {
                return price ? price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0';
            };

            return data.map(item => ({
                id: item.id,
                image: `${API_URL}${item.primary_image}`,
                tag: 'Paquetes',
                name: item.title,
                slug: item.slug,
                desc: item.description.length > 100 ? item.description.substring(0, 90) + '...' : item.description,
                package_type: item.package_type,
                tags: item.tags,
                price: formatPrice(item.price),
                price_discount: formatPrice(item.price_discount),
                price_members: formatPrice(item.price_members),
                hasdiscount: item.price_discount > 0 ? true : false,
                hasmembersprice: item.price_members > 0 ? true : false
            }));
        };
        if (csrfToken != null) {
            fetch(`${API_URL}/api/listings/package`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => {
                    setPaquetes(transformData(data));
                    setIsLoading(false);
                })
                .catch(error => console.error('Error fetching data:', error));
            fetch(`${API_URL}/api/filtertags`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => setTags(data))
                .catch(error => console.error('Error fetching data:', error));
        }
    }, [API_URL, csrfToken, member]);

    const [selectedTag, setSelectedTag] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };

    const handleTagChange = (event) => {
        setSelectedTag(event.target.value);
    };
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const shortcutTags = useMemo(() => [
        { label: 'Maternidad', value: 'maternidad', param: 'maternidad' },
        { label: 'Check up', value: 'check ups', param: 'check-ups' },
        { label: 'Laboratorio', value: 'laboratorio', param: 'laboratorio' },
        { label: 'Imagenología', value: 'imagenologia', param: 'imagenologia' }
    ], []);

    const normalizedShortcutMap = useMemo(() => {
        return shortcutTags.reduce((acc, shortcut) => {
            acc[removeAccents(shortcut.param.toLowerCase().trim())] = shortcut.value;
            acc[removeAccents(shortcut.value.toLowerCase().trim())] = shortcut.value;
            acc[removeAccents(shortcut.label.toLowerCase().trim())] = shortcut.value;
            return acc;
        }, {});
    }, [shortcutTags]);

    const normalizedTagMap = useMemo(() => {
        return tags.reduce((acc, tg) => {
            const normalizedTitle = removeAccents(tg.title.toLowerCase().trim());
            acc[normalizedTitle] = tg.id;
            return acc;
        }, {});
    }, [tags]);

    useEffect(() => {
        if (!initialShortcutTag) {
            setSelectedTag('');
            return;
        }

        if (tags.length === 0) {
            return;
        }

        const shortcutValue = normalizedShortcutMap[removeAccents(initialShortcutTag.toLowerCase().trim())];

        if (!shortcutValue) {
            setSelectedTag('');
            return;
        }

        const tagId = normalizedTagMap[removeAccents(shortcutValue.toLowerCase().trim())];
        setSelectedTag(tagId ? String(tagId) : '');
    }, [initialShortcutTag, normalizedShortcutMap, normalizedTagMap, tags.length]);

    const handleShortcutTagClick = (shortcutValue) => {
        const tagId = normalizedTagMap[removeAccents(shortcutValue.toLowerCase().trim())];
        setSelectedTag(tagId ? String(tagId) : '');
    };

    const filteredServices = useMemo(() => {
        return paquetes.filter(item => {
            const matchesTag = selectedTag
                ? item.tags.some(tg => tg.pivot.tag_id === parseInt(selectedTag))
                : true;

            const normalizedName = removeAccents(item.name.toLowerCase());
            const normalizedDesc = removeAccents(item.desc.toLowerCase());
            const normalizedSearch = removeAccents(searchTerm.toLowerCase());

            const matchesSearchTerm =
                normalizedName.includes(normalizedSearch) ||
                normalizedDesc.includes(normalizedSearch);

            return matchesTag && matchesSearchTerm;
        });
    }, [paquetes, selectedTag, searchTerm]);

    return (
        <>
            <div className="row justify-content-center bg-inverted py-2">
                <div className="col-12 text-center">
                        <span className='small'>Buscados frecuentemente</span><br />
                    <div className="d-flex flex-wrap justify-content-center gap-2 mb-2">
                            {shortcutTags.map((shortcut) => {
                                const shortcutTagId = normalizedTagMap[removeAccents(shortcut.value.toLowerCase().trim())];
                                const isActive = shortcutTagId && String(shortcutTagId) === selectedTag;

                                return (
                                    <button
                                        key={shortcut.value}
                                        type="button"
                                        className={`btn btn-sm ${isActive ? 'btn-success active' : 'btn-outline-success'}`}
                                        aria-pressed={Boolean(isActive)}
                                        onClick={() => handleShortcutTagClick(shortcut.value)}
                                    >
                                        {shortcut.label}
                                    </button>
                                );
                            })}
                        </div>
                </div>
            </div>
            <div className="row justify-content-center bg-inverted py-2">
                <div className="col-12 col-md-3">
                    <select name="specialties" className='form-control' data-no-translation value={selectedTag} onChange={handleTagChange}>
                        <option value="">Filtrar por área o especialidad</option>
                        <option value="">-Todo-</option>
                        {tags.map((tg, index) => (
                            <option key={index} value={tg.id}>{tg.title}</option>
                        ))}
                    </select>
                </div>
                <div className="col-12 col-md-3">
                    <input name="searchfield" type="text" className='form-control' placeholder='Buscar...' onChange={handleSearchChange} />
                </div>
            </div>
            <div className="row">
                {filteredServices.length > 0 ? (
                    filteredServices.map((item, index) => {
                        const stripTags = (html) => {
                            let doc = new DOMParser().parseFromString(html, 'text/html');
                            let textContent = doc.body.textContent || "";
                            return textContent.normalize("NFC");
                        };
                        return (
                            <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                                <div className="paquetes position-relative overflow-hidden shadow rounded p-4 d-flex flex-column h-100">
                                    <div className="position-relative">
                                        <div className="paquetes-image position-relative overflow-hidden rounded shadow object-fit-cover">
                                            <Link to={`/paquete/${item.slug}`}>
                                                <img src={item.image} className="img-fluid notransition" alt={item.name} />
                                            </Link>
                                        </div>

                                        <div className="position-absolute top-100 start-0 translate-middle-y ms-2">
                                            <span className="badge text-dark bg-light">{item.tag}</span>
                                        </div>
                                    </div>

                                    <div className="pt-4 flex-grow-1 d-flex flex-column">
                                        <Link to={`/paquete/${item.slug}`} className="text-dark title h5">{item.name}</Link>

                                        <p className="text-muted my-2 flex-grow-1">{stripTags(item.desc)}</p>
                                        {item.package_type === 'pricebased' && (
                                            <>
                                                {localmember.name != null && item.hasmembersprice ? (
                                                    <>
                                                        <div className="text-center text-decoration-line-through">{item.hasdiscount ? `Precio especial: $ ${item.price_discount}` : `Precio regular: $ ${item.price}`}</div>
                                                        <div className='small text-center text-success'>
                                                            Descuento exclusivo miembros Aranda +
                                                        </div>
                                                        <div className="text-center mb-2">${item.price_members}</div>
                                                    </>
                                                ) : (
                                                    <>
                                                        {item.hasdiscount && item.price !== null ? (
                                                            <div className="text-center mb-2">
                                                                <span className="text-decoration-line-through">${item.price}</span>
                                                                <br />
                                                                <span className="text-success">${item.price_discount}</span>
                                                            </div>
                                                        ) : (
                                                            <div className="text-center mb-2">${item.price}</div>
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}

                                        <Link to={`/paquete/${item.slug}`} className="btn btn-success w-100 btn-sm text-light mt-auto hv:bg-secondary">
                                            {item.package_type === 'pricebased' && (
                                                <>
                                                    Comprar <i className="mdi mdi-chevron-right align-middle"></i>
                                                </>
                                            )}
                                            {item.package_type === 'percentagebased' && (
                                                <>
                                                    Más información <i className="mdi mdi-chevron-right align-middle"></i>
                                                </>
                                            )}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                ) : (
                    <div className="col-12 mt-4 pt-2 text-center">
                        {isLoading ? (
                            <p className="text-muted">Cargando...</p>
                        ) : (
                            <p className="text-muted">Por el momento no hay paquetes disponibles.</p>
                        )}
                    </div>
                )}
            </div>
        </>
    )
}
